import React from 'react';
import { useNotification } from '../context/NotificationContext';
import { Check, AlertCircle, Info, AlertTriangle, X } from 'lucide-react';

const notificationStyles = {
  success: {
    bg: 'bg-green-50 border-green-200',
    text: 'text-green-800',
    icon: 'text-green-500',
    Icon: Check,
  },
  error: {
    bg: 'bg-red-50 border-red-200',
    text: 'text-red-800',
    icon: 'text-red-500',
    Icon: AlertCircle,
  },
  info: {
    bg: 'bg-blue-50 border-blue-200',
    text: 'text-blue-800',
    icon: 'text-blue-500',
    Icon: Info,
  },
  warning: {
    bg: 'bg-yellow-50 border-yellow-200',
    text: 'text-yellow-800',
    icon: 'text-yellow-500',
    Icon: AlertTriangle,
  },
};

export default function NotificationDisplay() {
  const { notifications, removeNotification } = useNotification();

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2 max-w-sm">
      {notifications.map(notification => {
        const style = notificationStyles[notification.type];
        const Icon = style.Icon;

        return (
          <div
            key={notification.id}
            className={`flex items-start gap-3 p-4 rounded-lg border ${style.bg} animate-in fade-in slide-in-from-top-2 duration-300`}
          >
            <Icon className={`w-5 h-5 mt-0.5 flex-shrink-0 ${style.icon}`} />
            <div className={`flex-1 text-sm font-medium ${style.text}`}>
              {notification.message}
            </div>
            <button
              onClick={() => removeNotification(notification.id)}
              className={`flex-shrink-0 ml-2 ${style.icon} hover:opacity-70 transition`}
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
